import List from './list' 

export default{
    list: List,
    
}